const setColorName = (color: string) => {
  if (color === "amarillo") return "Oro Amarillo";
  if (color === "blanco") return "Oro Blanco";
  if (color === "rojo") return "Oro Rojo";
  if (color === "soaked") return "Empavonado";
  if (color === "rose") return "Rosé";
  if (color === "golden") return "Dorado";
  if (color === "plata") return "Plata";
  else return "";
};

export default setColorName;
